/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_itinerary__options__caravan_toggle_helper_text = /** @type {(inputs: {}) => string} */ () => {
	return `Passt die Daten zu Kosten, Fahrzeit und Verbrauch an, aber nicht die Route`
};

const en_itinerary__options__caravan_toggle_helper_text = /** @type {(inputs: {}) => string} */ () => {
	return `Adapts cost, journey time and consumption data but not the route`
};

const es_itinerary__options__caravan_toggle_helper_text = /** @type {(inputs: {}) => string} */ () => {
	return `Adapta los datos de coste, duración del trayecto y consumo, pero no el itinerario`
};

const fr_itinerary__options__caravan_toggle_helper_text = /** @type {(inputs: {}) => string} */ () => {
	return `Adapte les données de coût, durée de trajet et consommation mais pas l’itinéraire`
};

const it_itinerary__options__caravan_toggle_helper_text = /** @type {(inputs: {}) => string} */ () => {
	return `Adatta i dati relativi a costi, tempi di percorrenza e consumi, ma non il percorso.`
};

const nl_itinerary__options__caravan_toggle_helper_text = /** @type {(inputs: {}) => string} */ () => {
	return `Past gegevens over kosten, reistijd en verbruik aan, maar niet de route`
};

const pt_itinerary__options__caravan_toggle_helper_text = /** @type {(inputs: {}) => string} */ () => {
	return `Adapta os dados de custo, tempo de viagem e consumo, mas não o itinerário`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__caravan_toggle_helper_text = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.itinerary__options__caravan_toggle_helper_text(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("itinerary__options__caravan_toggle_helper_text", locale)
	if (locale === "de") return de_itinerary__options__caravan_toggle_helper_text(inputs)
	if (locale === "en") return en_itinerary__options__caravan_toggle_helper_text(inputs)
	if (locale === "es") return es_itinerary__options__caravan_toggle_helper_text(inputs)
	if (locale === "fr") return fr_itinerary__options__caravan_toggle_helper_text(inputs)
	if (locale === "it") return it_itinerary__options__caravan_toggle_helper_text(inputs)
	if (locale === "nl") return nl_itinerary__options__caravan_toggle_helper_text(inputs)
	return pt_itinerary__options__caravan_toggle_helper_text(inputs)
};